import React from "react";
import { CheckCircle2, Award } from "lucide-react";

const POINTS = [
  "12+ let praxe se vším, co se týká vozidel",
  "Osobní přístup — víte, kdo se vám ozve",
  "Férové ceny předem písemně, žádné překvapení",
  "Vyzvednutí a předání vozu u vás doma nebo v práci",
];

export default function About() {
  return (
    <section
      id="o-nas"
      data-testid="about-section"
      className="relative bg-[#0A0D17] text-white py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 hero-grid opacity-30" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-amber-300/15 to-amber-500/5 blur-xl -z-10" />
              <div className="rounded-[1.75rem] border border-amber-300/20 bg-gradient-to-br from-[#0F1830] to-[#0A0D17] p-10 shadow-[0_30px_60px_-30px_rgba(0,0,0,0.7)]">
                <div className="flex justify-center">
                  <img
                    src="/brand/logo.png"
                    alt="STK Komfort Znojmo"
                    className="w-full max-w-[280px] aspect-square object-contain"
                  />
                </div>
                <div className="mt-2 h-px w-full bg-gradient-to-r from-transparent via-amber-300/40 to-transparent" />
                <div className="mt-6 text-center">
                  <div className="text-[11px] uppercase tracking-[0.2em] text-amber-300/80">
                    Vaše kontaktní osoba
                  </div>
                  <div className="font-heading mt-2 text-2xl font-bold text-white">
                    Lenka Garguláková
                  </div>
                  <div className="mt-1 text-sm text-slate-400">STK Komfort Znojmo™</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="text-xs uppercase tracking-[0.22em] text-amber-300 font-semibold">
              O nás
            </span>
            <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-balance">
              Lidský přístup, prémiový servis,{" "}
              <span className="bg-gradient-to-b from-amber-200 to-amber-500 bg-clip-text text-transparent">
                nulová ztráta vašeho času.
              </span>
            </h2>
            <p className="font-body mt-6 text-lg text-slate-300 leading-relaxed">
              Jsme malý tým ve Znojmě. Vaše auto bereme jako svoje — z bodu A do
              bodu B, přes STK, úřad i servis. Vy řešíte rodinu, práci a klienty.
              My řešíme auto.
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {POINTS.map((p) => (
                <li
                  key={p}
                  className="flex items-start gap-3 rounded-2xl border border-amber-300/15 bg-white/[0.03] p-5"
                >
                  <CheckCircle2 className="h-5 w-5 text-amber-300 mt-0.5 shrink-0" />
                  <span className="text-sm font-medium text-slate-200 leading-snug">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 inline-flex items-center gap-3 rounded-2xl border border-amber-300/20 bg-amber-300/5 px-5 py-3 text-sm text-amber-100">
              <Award className="h-4 w-4 text-amber-300" />
              Partner pro STK a emise: <strong className="font-semibold text-amber-200">PSOTA Znojmo</strong>
            </div>

            <p className="mt-5 text-xs text-slate-500 leading-relaxed max-w-2xl">
              STK a emise zajišťujeme přes partnerskou síť, zejména přes partnera PSOTA Znojmo.
              STK Komfort™ není stanice technické kontroly, ale profesionální asistenční služba,
              která klientovi pomáhá celý proces připravit, zorganizovat a vyřídit.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
